import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils/cn';
import { ApiError } from '@/lib/api/client';

/**
 * Inline error block. Accepts any thrown value; renders the message and
 * (for `ApiError`) the correlation id so a user can quote it to support.
 */
export function ErrorMessage({ error, className }: { error: unknown; className?: string }) {
  if (!error) return null;
  const isApi = error instanceof ApiError;
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error.';
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-md border border-destructive/50 bg-destructive/10 p-3 text-sm text-destructive',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <div className="space-y-1">
        <div className="font-medium">{message}</div>
        {isApi && (
          <div className="text-xs opacity-80">
            <span className="font-mono">{error.code}</span>
            {error.correlationId ? (
              <>
                {' '}
                · <span className="font-mono">{error.correlationId}</span>
              </>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
